import { render, staticRenderFns } from "./SuficienciaMovimientosForm.vue?vue&type=template&id=461fcd08&"
import script from "./SuficienciaMovimientosForm.vue?vue&type=script&lang=js&"
export * from "./SuficienciaMovimientosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports